export const Grain = () => <div className="film-grain" aria-hidden="true" />;
